/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Table_ActionsInputs */

const es_settings_dirs_table_actions = /** @type {(inputs: Settings_Dirs_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acciones`)
};

const en_settings_dirs_table_actions = /** @type {(inputs: Settings_Dirs_Table_ActionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actions`)
};

/**
* | output |
* | --- |
* | "Actions" |
*
* @param {Settings_Dirs_Table_ActionsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_table_actions = /** @type {((inputs?: Settings_Dirs_Table_ActionsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Table_ActionsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_table_actions(inputs)
	return en_settings_dirs_table_actions(inputs)
});
export { settings_dirs_table_actions as "settings.dirs.table.actions" }